define('urlHelper',[], function () {

  function getValueFromQueryString(parameter, url) {
    const params = new URL(url);
    const parameterValue = params.searchParams.get(parameter);
    return parameterValue;
  }

  function getValueFromUrlSegment(parameter, url) {
    const urlRegex = new RegExp(parameter + '(?:-([^&?\/]*))?', 'i');
    const match = urlRegex.exec(url);
    return match != null ? match[1] : null;
  }

  return {
    getValueFromQueryString: getValueFromQueryString,
    getValueFromUrlSegment: getValueFromUrlSegment
  }
});
